export default __webpack_public_path__ + "static/media/info.a0391f1b.jpg";